import { ws } from "../../../utils/common";

export const getMyAssociationsWS = async () => {
    const res = await ws(
        "GET",
        process.env.REACT_APP_ENDPOINT + "association/info?admin=true",
        null,
        null,
        true
    );

    if (res.error) {
        throw res.data.message;
    } else {
        return res.data;
    }

}